import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import * as sourceActions from './sourceReducer';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';
import { push } from 'react-router-redux';

export const defaultIncludes = [];

const createSource = (values) => {
  return (dispatch) => {
    return Axios.post('sources', values)
      .then((response) => {
        toastr.success('Success', 'source has been created');
        dispatch(push('/admin/sources/' + response.data.data.id));
        return response.data.data;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Source could not be created');
      });
  };
};

const getSource = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = 'sources/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint).then((response) => {
      dispatch({
        type: sourceActions.SET_SOURCE,
        data: response.data,
      });
      dispatch({
        type: ADD_RESOURCE,
        id: response.data.data.id,
        name: response.data.data.attributes.name,
      });
      return true;
    });
  };
};

const updateSource = (resourceId, values, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = 'sources/' + resourceId;
    endpoint += queryString(includes);
    return Axios.patch(endpoint, values)
      .then((response) => {
        dispatch({
          type: sourceActions.SET_SOURCE,
          data: response.data,
        });
        toastr.success('Success', 'source has been updated');
        return response.data;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed');
      });
  };
};

// const setSources = (brokerId) => {
//   let endpoint = 'sources?include=broker,source_type&filter[status]=active';
//
//   if (brokerId) {
//     endpoint += '&filter[broker]=' + brokerId;
//   }
//
//   return (dispatch) => {
//     return Axios.get(endpoint)
//       .then((response) => {
//         dispatch({
//           type: sourceActions.SET_SOURCES,
//           data: response.data.data,
//         });
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   };
// };

export const actions = {
  //setSources,
  updateSource,
  getSource,
  createSource,
};
